module.exports = __webpack_public_path__ + "static/img/first.81d0cc32.jpg";